import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Modal from 'react-modal';
import { NavLink, withRouter } from 'react-router-dom';
import appointmentSaga from '../Appointment/saga';

import Heroslider from '../../components/Heroslider';
import Footer from '../Footer';
import Header from '../Header';
import Meetsqueeze from './meetSqueeze';
import reCaptchaV3Plugin from '../../utils/third-party-plugins/recaptcha-v3';
import { compose } from 'redux';
import { fetchStatus } from '../Appointment/actions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectUser } from '../User/selectors';
import makeSelectMembership from '../Membership/selectors';
import makeSelectAppointment from '../Appointment/selectors';
import injectSaga from '../../utils/injectSaga';

Modal.setAppElement('#app');
// moved this styles to style sheet to make it responsive for mobile
// const customStyles = {
//   content: {
//     width: '100%',
//     left: '50%',
//     right: 'unset',
//     maxWidth: '560px',
//     transform: 'translateX(-50%)',
//     overflowX: 'hidden',
//     overflowY: 'auto',
//     background: '#fff',
//   },
// };

class HomePage extends React.Component {
  constructor() {
    super();
    this.state = { showModal: window.location.hash === '#thank-you' };
  }

  componentDidMount() {
    try {
      window.grecaptcha.ready(() => {
        reCaptchaV3Plugin('home_page');
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('reCaptchav3 init error - Home:', err);
    }
  }
  componentWillUnmount ()
  {
  const authToken = localStorage.getItem('userToken');
   if(authToken) this.props.fetchStatus();
  }
  
  thankYou() {
    return (
      <Modal isOpen={this.state.showModal} className="thankyouModal">
        <button
          type="button"
          className="modal__close btn-icon icon js-modal-close preg-modal__close"
          onClick={() => this.setState({ showModal: false })}
        />
        <h3 className="thankyouHeading">THANK YOU!</h3>
        <div className="thankyouInfo">
          Your application has been sent,<br />we’ll get back to you shortly.
        </div>
        <div className="thankyouSvg" />
        {/* <script dangerouslySetInnerHTML={{__html: `window.datalayer = gtag('event', 'conversion', {'send_to': 'AW-790725028/DM46COaDsbgBEKSDhvkC'});` }}/> */}
      </Modal>
    );
  }

  render ()
  {
    return (
      <Fragment>
        <div className="homeWrap">
          <Helmet>
            <title>A Way Better Massage Experience | Home </title>
            <meta
              name="description"
              content="Book, pay and tip on the app or website. It’s a snap! After your massage, you can just float on out! Save your preferences so your therapist knows what you want each and every time. Easy, peasy, Squeezy."
            />
          </Helmet>
          <Header
            showCloseButton={false}
            showBackButton={false}
            showQuicklinks
            showLogoOnPage
            showHamburgerMenu
          />
          <Heroslider />
          <Meetsqueeze />
          <div className="marginBottomforHomepageFooter">
            <Footer showItems />
          </div>
          <div className="phone-only bookMassageBtnMobile">
            <NavLink
              aria-label="book-massage"
              to="/appointment/locations"
              id="bookMassage-home"
              className="btn"
            >
              Book A Massage
            </NavLink>
          </div>
          {this.state.showModal && this.thankYou()}
        </div>
      </Fragment>
    );
  }
}

HomePage.prototypes = {
  fetchStatus: PropTypes.func,
  appointmentData: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  membershipData: makeSelectMembership(),
  appointmentData: makeSelectAppointment(),
});

const withConnect = connect(
  mapStateToProps,
  {
    fetchStatus,
  },
);

const withSagaFetchStatus = injectSaga({
  key: 'fetchStatus',
  saga: appointmentSaga.watchFetchStatus,
} );

export default compose(
  withRouter,
  withSagaFetchStatus,
  withConnect,
)(HomePage);